import React, { useContext, useMemo } from "react";
import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import moment from "moment";
import EmblaCarousel from "./carousel/EmblaCarousel";
import ConfigContext from "../context/ConfigContext";

/** Banner slides with optional endDate (YYYY-MM-DD); shown while today is on or before endDate. */
function getVisibleBannerSlides(banner) {
  if (!Array.isArray(banner) || !banner.length) {
    return [];
  }
  return banner.filter((o) => {
    if (!o?.endDate) {
      return true;
    }
    return moment().isSameOrBefore(moment(o.endDate, "YYYY-MM-DD"), "day");
  });
}

export default function SiteBanner() {
  const siteConfig = useContext(ConfigContext);

  const slides = useMemo(() => getVisibleBannerSlides(siteConfig?.banner), [siteConfig?.banner]);

  if (!slides.length) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: siteConfig?.theme?.palette?.primary || "#333",
        color: "#FFFFFF",
        padding: "10px",
        textAlign: "center",
      }}
    >
      <EmblaCarousel>
        {slides.map((o, idx) => (
          <Link
            key={idx}
            aria-label={o.text}
            underline="none"
            component={RouterLink}
            to={o.link}
            sx={{ color: "inherit" }}
          >
            <Box>
              <Typography variant="body2">{o.text}</Typography>
            </Box>
          </Link>
        ))}
      </EmblaCarousel>
    </Box>
  );
}
